export const appTypes = [
  { name: 'Chat', value: 'chat' },
  { name: 'Screening', value: 'screening' }
];

export const products = [
  { name: 'AskNivi', value: 'asknivi' },
  { name: 'FP Screening', value: 'fpscreening' }
]

export const appPackages = [
  { name: 'Conversation', value: 'conversation' },
  { name: 'Screening Woman', value: 'screeningwoman' },
  { name: 'Chatbot', value: 'chatbot' },
  { name: 'Chatbot V2', value: 'chatbotv2' },
  { name: 'User Journey', value: 'journey'}
]

export const customerContracts = [
  { name: 'Subscription', value: 1 },
  { name: 'MarketPlace', value: 2 },
  { name: 'Prospect', value: 3 }
]

export const offeringType = [
  { name: 'Product', value: 'Product' },
  { name: 'Service', value: 'Service' }
]

export const channels = [
  { name: 'Cards', value: 'Cards' },
  { name: 'SMSBlast', value: 'SMSBlast' },
  { name: 'PilotTrial', value: 'PilotTrial' },
  { name: 'Facebook', value: 'Facebook' },
  { name: 'Demo', value: 'Demo' },
  { name: 'Level1-Adwords', value: 'Level1-Adwords' },
  { name: 'Level1-FB', value: 'Level1-FB' },
  { name: 'Salon', value: 'Salon' },
  { name: 'Facebook Messenger', value: 'Facebook Messenger' },
  { name: 'Intercom', value: 'Intercom' },
  { name: 'WhatsApp', value: 'WhatsApp' },
  { name: 'Other', value: 'Other' },
  { name: 'Nivi Website', value: 'Nivi Website' },
  { name: 'Nivi Website to WhatsApp', value: 'Nivi Website to WhatsApp' },
  { name: 'Nivi Website to Messenger', value: 'Nivi Website to Messenger' },
  { name: 'Other Website to WhatsApp', value: 'Other Website to WhatsApp' },
  { name: 'Other Website to Messenger', value: 'Other Website to Messenger'},
  { name: 'QR Code Scan', value: 'QR Code Scan'}
]

export const channelOptions = [{
  label: 'WhatsApp',
  value: 'whatsapp'
}, {
  label: 'Facebook',
  value: 'messenger'
}, {
  label: 'SMS',
  value: 'sms'
}, {
  label: 'Line',
  value: 'line'
}];

export const genderOptions = [
  { label: 'Woman', value: 'woman' },
  { label: 'Man', value: 'man' },
  { label: 'Non Binary', value: 'nonbinary' }
];

export const languages = [
  { name: 'English', value: 'eng' },
  { name: 'Swahili', value: 'swa' },
  { name: 'Hindi', value: 'hi' },
  { name: 'Marathi', value: 'mar' },
  { name: 'Hausa', value: 'hau' },
  { name: 'Gujarati', value: 'guj' },
  { name: 'Tamil', value: 'tam' },
  { name: 'Odia', value: 'odi' },
  { name: 'Assamese', value: 'asm' },
  { name: 'Kannada', value: 'kan' },
  { name: 'Telugu', value: 'tel' },
  { name: 'Thai', value: 'tha' },
  { name: 'Indonesian', value: 'ind' }
]

export const instances = [
  { name: 'Staging (India + Africa)', value: 'staging' },
  { name: 'Production (India + Africa)', value: 'production' }
]

export const instanceNames = {
  'staging-ap-south-1': 'India Staging',
  'staging-eu-central-1': 'Kenya Staging',
  'production-ap-south-1': 'India Production',
  'production-eu-central-1': 'Kenya Production'
}

export const domain = {
  localhost: {
    defaultConversationCountry: 'India',
    clickUrlDomain: 'https://xs.nivi.io/'
  },
  'dashboard.mynivi.in': {
    defaultConversationCountry: 'India',
    clickUrlDomain: 'https://x.nivi.io/'
  },
  'india-dashboard-staging.herokuapp.com': {
    defaultConversationCountry: 'India',
    clickUrlDomain: 'https://xs.nivi.io/'
  },
  'eu-dashboard-staging.herokuapp.com': {
    defaultConversationCountry: 'Kenya',
    clickUrlDomain: 'https://ys.nivi.io/'
  },
  'dashboard.mynivi.ke': {
    defaultConversationCountry: 'Kenya',
    clickUrlDomain: 'https://y.nivi.io/'
  }
}
export const instanceCountriesMapping = {
  localhost: {
    countries: ['india', 'kenya', 'nigeria', 'thailand', 'india_msd', 'indonesia', 'uganda', 'malaysia', 'singapore']
  },
  'dashboard.mynivi.in': {
    countries: ['india', 'thailand', 'india_msd', 'indonesia', 'malaysia', 'singapore']
  },
  'india-dashboard-staging.herokuapp.com': {
    countries: ['india', 'thailand', 'india_msd', 'indonesia', 'malaysia', 'singapore']
  },
  'eu-dashboard-staging.herokuapp.com': {
    countries: ['kenya', 'nigeria', 'uganda']
  },
  'dashboard.mynivi.ke': {
    countries: ['kenya', 'nigeria', 'uganda']
  }
}
export const standAloneApps = [
  { name: 'chatbot', value: 'APP_CHATBOT' },
  { name: 'WhatsApp Migrate', value: 'WA_MIGRATE' },
  { name: 'SMS Feedback', value: 'APP_SMS_FEEDBACK' },
  { name: 'Location for Referral', value: 'APP_LOCATION' },
  { name: 'ANC Signup App', value: 'APP_ANC' },
  { name: 'ANC Unsubscribe App', value: 'APP_ANC_UNSUBSCRIBE' },
  { name: 'ANC Due Date Verify', value: 'APP_ANC_DUE_DATE_VERIFY' },
  { name: 'End Conversation', value: 'END_CONVERSATION' },
  { name: 'PNC Signup App', value: 'APP_PNC' },
  { name: 'PNC Unsubscribe App', value: 'APP_PNC_UNSUBSCRIBE' },
  { name: 'PNC Birth Date Verify', value: 'APP_PNC_BIRTH_DATE_VERIFY' },
  { name: 'PNC Birth Followup', value: 'APP_PNC_BIRTH_FOLLOWUP' },
  { name: 'Replay', value: 'REPLAY' },
  { name: 'Unified Referral', value: 'APP_UNIFIED_REFERRAL' },
  { name: 'Scout', value: 'SCOUT' },
  { name: 'Schedule Conversation', value: 'SCHEDULE_CONVERSATION' },
  { name: 'Schedule MA Conversation', value: 'SCHEDULE_MA_APP' },
  { name: 'Book Appointment'  , value: 'APP_BOOK_APPOINTMENT' },
]


//////////////////
// WEBPACK FOOTER
// ./config/constants.js
// module id = aurM
// module chunks = 1